import React from 'react';
import BaseCreatePage from '../../_CustomComponents/BaseCreatePage';
import { connect } from "react-redux";
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import * as inspectionCrud from '../../../../crud/inspectionDefect.crud';
import PortletSpinner from '../../../../partials/layout/PortletSpinner';
import { Portlet, PortletBody, PortletHeader } from "../../../../partials/content/Portlet";
import { Alert } from "react-bootstrap";
import moment from 'moment';
import { addYears } from 'date-fns';
import { FormattedMessage } from "react-intl";
import DataSource from 'devextreme/data/data_source';
import Common from '../../../../shared/common';
import { withCreatePageProps } from '../../../../shared/hoc/withCreatePageProps';
import { actionCodes } from "../../../../shared/lookup";

class ActionCreatePage extends BaseCreatePage {
    constructor(props) {
        super(props);
        const { subject } = ((props.location.state || {}).itemCustomProps || {});
        const { fields } = props.workflowItem;
        const partyDataSource = this.getPartyDataSource();
        this.createFormConfig = {
            buttonResource: "GENERAL.FORMS.BUTTON_CREATE_DRAFT",
            fields: [
                { label: fields.Subject.label, dataField: 'assistancetestserchdefect', editorOptions: { defaultValue: subject } },
                { label: fields.Details.label, dataField: 'inspectiondetails', editorType: 'dxHtmlEditor' },
                { label: fields.DelegatedTo.label, dataField: 'replyactiondetail', editorType: 'dxSelectBox', editorOptions: { dataSource: partyDataSource, valueExpr: 'user', displayExpr: 'user', grouped: props.allowCrossPartyDelegationsIsEnabled } },
                {
                    resource: "CONTRACT.WF.DELEGATION.FIELD.TIME_SPAN",
                    fields: [
                        { label: fields.StartDate.label, dataField: 'inspectiondatedisplay', editorType: 'dxDateBox', editorOptions: { calendarOptions: { min: new Date() }, max: addYears(new Date(), 10) }, validation: { type: 'range', min: moment().subtract(1, 'days'), max: addYears(new Date(), 10), warning: this.props.intl.formatMessage({ id: "GENERAL.FORMS.INVALID_DATE" })} },
                        { label: fields.EndDate.label, dataField: 'inspectiontime', editorType: 'dxDateBox', editorOptions: { calendarOptions: { min: new Date() }, max: addYears(new Date(), 10) }, validation: { type: 'range', min: moment().subtract(1, 'days'), max: addYears(new Date(), 10), warning: this.props.intl.formatMessage({ id: "GENERAL.FORMS.INVALID_DATE" })} },
                    ]
                }
            ]
        };
        this.state = {
            showAlert: true
        };
    }

    getPartyDataSource = () => {
        if (this.props.contractUsers) {
            if (this.props.allowCrossPartyDelegationsIsEnabled) {
                const mappedContractUsers = this.props.contractUsers.map(x => ({
                    userid: x.accountid,
                    user: x.user,
                    party: Common.GetPartyDisplay(x.usergroup, this.props.globalResources)
                }));
                const groupedUserList = new DataSource({
                    store: {
                        type: 'array',
                        data: mappedContractUsers,
                        key: 'userid'
                    },
                    group: 'party'
                });
                return groupedUserList;
            }
            else {
                const mappedContractUsers = this.props.contractUsers.filter(user => user.usergroup === this.props.delegationUserParty).map(x => ({
                    userid: x.accountid,
                    user: x.user
                }))
                return mappedContractUsers;
            }
        }
        return null;
    }
    submitHandler = (notification, setSubmitting) => {
        notification.companyid = this.props.contract.companyid;
        notification.contractid = this.props.contract.contractid;
        notification.projectid = this.props.contract.projectid;
        notification.replystatus = 'Not Communicated';
        // notification.notificationdatedisplay = moment().format('DD/MM/YYYY');
        notification.type = this.props.notificationType;
        if (notification.inspectiondatedisplay) {
            notification.inspectiondatedisplay = moment(notification.inspectiondatedisplay).format('DD/MM/YYYY HH:mm:ss');
        }
        if (notification.inspectiontime) {
            notification.inspectiontime = moment(notification.inspectiontime).format('DD/MM/YYYY');
        }
        notification.actioncode = actionCodes.CREATE;
        notification.workflowid = this.props.workflowItem.id;
        this.appendRelationship(notification);
        Common.PropertyConversionsBeforeNoticeSaveRequest(notification, this.props.customFields, this.props.contractUsers);
        inspectionCrud.saveInspectionDefect(notification)
            .then(response => {
                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.COMMUNICATON.DRAFT_SUCCESS' }), { variant: 'success', });
                try {
                    const createdID = Number(response.data);
                    this.props.navigate(this.props.workflowItem.paths.basePath + createdID);
                }
                catch {
                    this.props.navigate(this.props.workflowItem.paths.listPath);
                }
            })
            .catch(err => {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', key: "PersistentFormWarning", persist: true });
            });

    }

    render() {
        if (!this.props.contractUsers) {
            return (<PortletSpinner />);
        }
        const { assetid } = ((this.props.location.state || {}).itemCustomProps || {});

        // this.createFormConfig.fields[2].editorOptions.dataSource = this.props.contractUsers.filter(user => user.usergroup === this.props.delegationUserParty);
        return (
            <Portlet>
                <PortletHeader title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.CREATE_TITLE' }, { ITEM_NAME: this.props.workflowItem.pageTitle })} />
                <PortletBody style={{ maxWidth: 1000 }}>
                    {this.state.showAlert && (
                        <Alert variant="secondary" onClose={() => this.setState({ showAlert: false })} dismissible>
                            <p>
                                <FormattedMessage id="GENERAL.FORMS.WARNING_DRAFT" />
                            </p>
                        </Alert>
                    )}
                    <BiDynamicForm
                        onSubmitHandler={this.submitHandler}
                        config={this.createFormConfig}
                        customFields={(this.props.customFields || {}).COMMUNICATION}
                        assetFieldsEnabled={this.props.workflowItem.assetFieldsEnabled}
                        assetid={assetid}
                    />
                </PortletBody>
            </Portlet>
        );
    }
}

const mapStateToProps = store => ({
    contractUsers: store.contract.users
});

export default withCreatePageProps(connect(mapStateToProps)(ActionCreatePage));
